import React from 'react';

function RefundPolicy({ navigate }) {
  return (
    <div style={s.root}>
      <link href="https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;500;600;700&family=Noto+Sans+KR:wght@300;400;500;700&display=swap" rel="stylesheet" />
      <nav style={s.nav}>
        <div style={s.navInner}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }} onClick={() => navigate('landing')}>
            <span>🏒</span>
            <span style={{ fontSize: 22, fontWeight: 700, color: '#5BC4D8', fontFamily: "'Rajdhani', sans-serif", letterSpacing: 2 }}>IonIce</span>
          </div>
          <span onClick={() => navigate('landing')} style={{ color: '#778899', fontSize: 13, cursor: 'pointer' }}>← 홈으로</span>
        </div>
      </nav>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 32px' }}>
        <h1 style={{ fontSize: 32, fontWeight: 700, color: '#fff', fontFamily: "'Rajdhani', sans-serif", margin: '0 0 8px' }}>취소 및 환불 규정</h1>
        <p style={{ color: '#667788', fontSize: 13, margin: '0 0 48px' }}>최종 수정일: 2026년 3월 5일</p>

        {sections.map((sec, i) => (
          <section key={i} style={{ marginBottom: 32 }}>
            <h2 style={{ fontSize: 18, fontWeight: 600, color: '#5BC4D8', margin: '0 0 12px' }}>{sec.title}</h2>
            {sec.paragraphs.map((p, j) => (
              <p key={j} style={{ fontSize: 14, lineHeight: 1.8, color: '#AAB4C0', margin: '0 0 12px' }} dangerouslySetInnerHTML={{ __html: p }} />
            ))}
          </section>
        ))}
      </div>
      <footer style={{ borderTop: '1px solid rgba(91,196,216,0.06)', padding: '24px 32px' }}>
        <div style={{ maxWidth: 800, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <p style={{ color: '#556677', fontSize: 12, margin: 0 }}>© 2026 IonIce. All rights reserved.</p>
          <span onClick={() => navigate('landing')} style={{ color: '#667788', fontSize: 12, cursor: 'pointer' }}>ionice.hockey</span>
        </div>
      </footer>
    </div>
  );
}

const sections = [
  {
    title: '1. 서비스 개요',
    paragraphs: [
      'IonIce는 아이스하키 동호회를 위한 팀 관리 플랫폼으로, 앱 내에서 회비 납부 및 게스트 참가비 등의 전자결제 서비스를 제공합니다.',
      '본 규정은 IonIce 서비스 내 전자결제를 통한 결제 건에 대한 취소 및 환불 절차를 안내합니다.',
    ],
  },
  {
    title: '2. 회비 결제 취소 및 환불',
    paragraphs: [
      '<strong>결제 후 7일 이내:</strong> 팀 활동(훈련, 경기 등)에 참여하지 않은 경우, 결제 금액의 100%를 환불받을 수 있습니다.',
      '<strong>결제 후 7일 초과 ~ 30일 이내:</strong> 팀 활동에 참여하지 않은 경우, 결제 금액의 80%를 환불받을 수 있습니다. (PG 수수료 및 운영비 차감)',
      '<strong>결제 후 30일 초과 또는 활동 참여 후:</strong> 환불이 불가합니다.',
    ],
  },
  {
    title: '3. 게스트 참가비 취소 및 환불',
    paragraphs: [
      '<strong>경기/훈련 시작 24시간 전까지:</strong> 100% 환불 가능합니다.',
      '<strong>경기/훈련 시작 24시간 이내 ~ 시작 전:</strong> 50% 환불 가능합니다.',
      '<strong>경기/훈련 시작 이후:</strong> 환불이 불가합니다.',
      '게스트 참가 승인이 거절된 경우, 결제 금액의 100%가 자동으로 환불됩니다.',
    ],
  },
  {
    title: '4. 환불 처리 절차',
    paragraphs: [
      '환불 요청은 IonIce 앱 내 또는 이메일(<strong>admin@ionice.hockey</strong>)을 통해 접수할 수 있습니다.',
      '환불 요청 접수 후 영업일 기준 3~5일 이내에 처리되며, 결제 수단에 따라 실제 환불 소요 기간이 상이할 수 있습니다.',
      '카드 결제의 경우 카드사 사정에 따라 환불까지 최대 7영업일이 소요될 수 있습니다.',
    ],
  },
  {
    title: '5. 환불 불가 사유',
    paragraphs: [
      '다음의 경우에는 환불이 불가합니다:',
      '• 이미 팀 활동(훈련, 경기 등)에 참여한 경우<br />• 결제 후 30일이 초과된 경우<br />• 본인의 귀책 사유로 팀에서 제명된 경우<br />• 환불 규정에 명시된 환불 기한을 초과한 경우',
    ],
  },
  {
    title: '6. 기타',
    paragraphs: [
      '본 규정에 명시되지 않은 사항은 「전자상거래 등에서의 소비자보호에 관한 법률」 및 관련 법령에 따릅니다.',
      '서비스 운영 사정에 따라 본 규정은 사전 공지 후 변경될 수 있습니다.',
    ],
  },
  {
    title: '7. 문의처',
    paragraphs: [
      '<strong>상호명:</strong> 코스모소나플렉스 유한회사<br /><strong>대표자:</strong> 손태무<br /><strong>이메일:</strong> admin@ionice.hockey<br /><strong>주소:</strong> 서울특별시 중구 마른내로4가길 17, 인현동L빌딩 301호',
    ],
  },
];

const s = {
  root: { fontFamily: "'Noto Sans KR', sans-serif", backgroundColor: '#0A1220', color: '#E8ECF1', minHeight: '100vh' },
  nav: { borderBottom: '1px solid rgba(91,196,216,0.08)', backgroundColor: 'rgba(10,18,32,0.95)', position: 'sticky', top: 0, zIndex: 100, backdropFilter: 'blur(20px)' },
  navInner: { maxWidth: 800, margin: '0 auto', padding: '16px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
};

export default RefundPolicy;
